/** The newest of a lineage's revisions, by version. */
export function latestRevision<T extends { version: number }>(revisions: readonly T[]): T | undefined {
  return [...revisions].sort((left, right) => right.version - left.version)[0];
}
